<template>
    <div>
        <div class="review--block--header" @click="() => { this.$emit('toggled', { selected: this.selected }) }">
            <div class="review--block--header--icon" v-html="shield"></div>
            <div class="review--block--header--title">
                <div>
                    {{ service.details.title }}
                </div>
            </div>
            <div class="review--block--header--checked" v-html="checked"></div>
        </div>
        <div v-show="opened">
            <div class="panel tiny-mce" transparent noradius noshadow v-if="service.public_data.service_notes" v-html="service.public_data.service_notes"></div>
            <review-agent-notes v-if="service.public_data.agent_notes" :agent_notes="service.public_data.agent_notes" />
            <div class="panel" noradius>
                <review-service-highlight
                    :price="service.public_data.public_price"
                    :adults="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.adults : ''"
                    :children="this.$store.state.quote.details.occupancy ? this.$store.state.quote.details.occupancy.children : []"
                />                
            </div>
            <div class="review--block--body">
                <!--<b-form-radio-group v-model="selected">-->
                    <b-row>
                        <b-col>
                            <div class="review--option">
                                <div class="review--option--content tiny-mce" v-html="service.details.freetext"></div>
                                <div class="review--option--control">
                                    <!--<b-form-radio name="review-transfers" :value="transfer.transfer_index"></b-form-radio>-->
                                </div>
                            </div>                        
                        </b-col>
                    </b-row>
                <!--</b-form-radio-group>-->
            </div>
            <div class="panel" transparent noradius noshadow v-if="service.public_data.public_notes">
                <div class="review--title--small">
                    <strong>Note, istruzioni e condizioni della soluzione</strong>
                </div>
                <div class="tiny-mce" v-html="service.public_data.public_notes"></div>
            </div>
            <!--
            <div class="review--block--footer">
                <button-with-icon
                    variant="cta"
                    text="Chiudi"
                    :disabled="selected == -1"
                    :icon="chevron_right"
                    :clicked="() => { this.$emit('completed', { selected: this.selected }) }"
                />
            </div>-->
        </div>
    </div>
</template>


<script>
    //import Bwi from '@/components/atoms/button-with-icon'
    import ReviewServiceHighlight from '@/components/review/review-service-highlight'
    import ReviewAgentNotes from '@/components/review/review-agent-notes'
    //import { validate_fields } from '@/validate'
    import { shield, checked, info } from '@/components/svg/common'
    import { chevron_right } from '@/components/svg/chevrons'
    export default {
        name: 'review-transfer',
        components: {
            //'button-with-icon': Bwi,
            'review-service-highlight': ReviewServiceHighlight,
            'review-agent-notes': ReviewAgentNotes,
        },
        props:
        {
            opened: {
                type: Boolean,
                default: false,
            },
            service: {
                type: Object,
                default: () => {}
            },
        },
        created()
        {
            this.shield = shield
            this.checked = checked
            this.info = info
            this.chevron_right = chevron_right
            //this.validate_fields = validate_fields
        },
        data() {
            return {
                selected: 0,//-1,
                options: [],
            }
        },
        computed: {
        },
        mounted() {
            this.$emit('completed', { selected: this.selected })
        },
        methods:{
        },
    }
</script>

<style lang="scss">
    #review-transfer
    {
    }
</style>